function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { filterMixin } from '@/mixins/filter_mixin';
import { localPaginationMixin } from '@/mixins/local_pagination';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import { mapState, mapMutations } from 'vuex';
import tasks from '@/js/tasks';
import { STATUS_ATTRIBUTES, TYPES_EXPORT_ATTRIBUTES, ENVIRONMENT_ATTRIBUTES } from '@/js/constants';
import ProductizeTransformedAttributeDetail from '@/apps/attributes/modules/use_cases/ProductizeTransformedAttributeDetail.vue';
import utils from '@/js/utils';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
export default {
  name: 'OwnershipHistoryPage',
  components: {
    DialogsComponent: DialogsComponent,
    ProductizeTransformedAttributeDetail: ProductizeTransformedAttributeDetail,
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    return _defineProperty({
      pausedItem: null,
      observedItem: null,
      ENVIRONMENT_ATTRIBUTES: ENVIRONMENT_ATTRIBUTES,
      STATUS_ATTRIBUTES: STATUS_ATTRIBUTES,
      TYPES_EXPORT_ATTRIBUTES: TYPES_EXPORT_ATTRIBUTES,
      filter_enabled: true,
      isLoading: false,
      DIALOG_VIEW: 'DIALOG_VIEW',
      search: '',
      domain: window.userInfo.domain,
      filters: {
        text_filter: ''
      },
      form: {
        type_export: null,
        selected_use_case: null,
        segment: null,
        description: null,
        unique_load: false,
        buttonSelected: '1_DAY',
        number_day: null,
        weekDays: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
        week_day: null,
        number: '',
        descargar_archivo: null,
        project_id: null,
        segment_id: null,
        type_export_id: null,
        response_text: null,
        has_pls: false
      },
      selected_item: {},
      items: [],
      items_filter: [],
      headers: [{
        text: 'Caso de uso',
        value: 'caso_de_uso'
      }, {
        text: 'Segmento / Tabla',
        value: 'segmento'
      }, {
        text: 'Tipo exportación',
        value: 'tipo_exportacion'
      }, {
        text: 'Empresa',
        value: 'company_name'
      }, {
        text: 'Fecha Creación',
        value: 'fecha_creacion'
      }, {
        text: 'Fecha Actualización',
        value: 'fecha_actualizacion'
      }, {
        text: 'Carga única',
        value: 'carga_unica'
      }, {
        text: 'Frecuencia',
        value: 'frecuencia'
      }, {
        text: 'Día',
        value: 'dia'
      }, {
        text: 'Ambiente',
        value: 'environment'
      }, {
        text: 'Estado',
        value: 'estado'
      }, {
        text: '',
        value: 'action'
      }]
    }, "filters", {
      estado: 16
    });
  },
  created: function created() {
    this.STATUS_ATTRIBUTES.unshift({
      value: "",
      text: ".: TODOS :."
    });
    this.TYPES_EXPORT_ATTRIBUTES.unshift({
      value: "",
      text: ".: TODOS :."
    });
    this.init();
  },
  methods: _objectSpread(_objectSpread({
    fetchPage: function () {
      var _fetchPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, response, payload, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.setShowLoading(true);
              params = {
                user: window.userInfo.email,
                role: 1,
                sbidv: 1,
                page: this.pagination.current,
                page_size: this.pagination.limit,
                use_case: this.filters.use_case || '',
                segment: this.filters.segment || '',
                type: this.filters.type || '',
                estado: this.filters.estado || '',
                ambiente: this.filters.ambiente || ''
              };
              _context.n = 1;
              return UseCasesService.getProductizeHistory({
                params: params
              });
            case 1:
              response = _context.v;
              // OJO: según tu controlador, la data viene en data.data
              payload = response.data; // registros de la página actual
              this.items = payload.records || [];

              // total de registros (para que funcione tu <pagination-vue>)
              this.pagination.total = payload.total || 0;

              // opcional: si quieres ver páginas
              // payload.page, payload.page_size, payload.total_pages, payload.has_next, payload.has_prev
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error(_t);
              tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
            case 3:
              _context.p = 3;
              this.setShowLoading(false);
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2, 3, 4]]);
      }));
      function fetchPage() {
        return _fetchPage.apply(this, arguments);
      }
      return fetchPage;
    }()
  }, mapMutations('app', ['setShowLoading'])), {}, {
    onLimpiar: function onLimpiar() {
      this.filters = {
        estado: 16
      };
      this.pagination.current = 1;
      this.fetchPage();
    },
    onBuscar: function onBuscar() {
      this.pagination.current = 1;
      this.fetchPage();
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    formatDate: function formatDate(dateString) {
      if (dateString) {
        var options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
      }
      return '';
    },
    viewDetailExport: function viewDetailExport(item) {
      this.selected = item;
      this.openDialog('DIALOG_DETAIL_EXPORT');
    },
    viewDetail: function viewDetail(item) {
      var _this = this;
      console.log(item);
      UseCasesService.getProductizeDetail({}, item.project_id, item.segment_id, item.type_export_id).then(function (response) {
        var records = response.data.records;
        _this.form.descargar_archivo = records.descargar_archivo;
        _this.form.selected_use_case = records.caso_de_uso;
        _this.form.type_export = records.tipo_de_exportacion;
        _this.form.segment = item.segmento;
        _this.form.user = records.usuario;
        _this.form.frequency = records.frecuencia;
        _this.form.day = records.dia;
        _this.form.date_hour = records.fecha_y_hora;
        _this.form.description = records.descripcion_tabla;
        _this.form.project_id = item.project_id;
        _this.form.segment_id = item.segment_id;
        _this.form.type_export_id = item.type_export_id;
        _this.form.has_pls = records.has_pls;
        _this.form.carga_unica = item.carga_unica;
        _this.form.fecha_creacion = item.fecha_creacion;
        console.log(response.data.records, 'records');
        _this.setShowLoading(false);
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this.translate('error_messages.error_general'), _this.translate('titles.error'));
        _this.setShowLoading(false);
      });
      this.openDialog(this.DIALOG_VIEW);
    },
    observedUsecase: function observedUsecase(item) {
      this.observedItem = item;
      this.$refs.dialogObservedUseCase.onOpen();
    },
    onConfirmObserved: function () {
      var _onConfirmObserved = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(confirmed) {
        var response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              console.log('confirmed', confirmed);
              if (confirmed) {
                _context2.n = 1;
                break;
              }
              this.$refs.dialogObservedUseCase.onClose();
              return _context2.a(2);
            case 1:
              if (this.observedItem) {
                _context2.n = 2;
                break;
              }
              this.$refs.dialogObservedUseCase.onClose();
              return _context2.a(2);
            case 2:
              _context2.p = 2;
              this.setShowLoading(true);
              _context2.n = 3;
              return UseCasesService.observedUsecase(this.observedItem.automate_id);
            case 3:
              response = _context2.v;
              this.$refs.dialogObservedUseCase.onClose();
              if (response.code_message === '00') {
                tasks.toast.success(this.translate('success_messages.usecase_observed'), this.translate('titles.success'));
                this.init();
              } else {
                tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error(_t2);
              tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
            case 5:
              _context2.p = 5;
              this.setShowLoading(false);
              this.observedItem = null;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function onConfirmObserved(_x) {
        return _onConfirmObserved.apply(this, arguments);
      }
      return onConfirmObserved;
    }(),
    pausedUsecase: function pausedUsecase(item) {
      this.pauseItem = item;
      this.$refs.dialogPauseUseCase.onOpen();
    },
    onConfirmPause: function () {
      var _onConfirmPause = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(confirmed) {
        var response, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (confirmed) {
                _context3.n = 1;
                break;
              }
              this.$refs.dialogPauseUseCase.onClose();
              return _context3.a(2);
            case 1:
              if (this.pauseItem) {
                _context3.n = 2;
                break;
              }
              this.$refs.dialogPauseUseCase.onClose();
              return _context3.a(2);
            case 2:
              _context3.p = 2;
              this.setShowLoading(true);
              _context3.n = 3;
              return UseCasesService.pausesUsecase(this.pauseItem.automate_id);
            case 3:
              response = _context3.v;
              if (response.code_message === '00') {
                tasks.toast.success(this.translate('success_messages.usecase_paused'), this.translate('titles.success'));
                this.init();
              } else {
                tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
              }
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.error(_t3);
              tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
            case 5:
              _context3.p = 5;
              this.setShowLoading(false);
              this.pauseItem = null;
              this.$refs.dialogPauseUseCase.onClose();
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function onConfirmPause(_x2) {
        return _onConfirmPause.apply(this, arguments);
      }
      return onConfirmPause;
    }(),
    onCloseDialogSuccess: function onCloseDialogSuccess(modalName) {
      this.$refs[modalName].onClose();
      tasks.toast.success(this.translate('success_messages.general'), this.translate('titles.success'), 'ownership_history');
    },
    onSearch: function onSearch() {
      this.search = this.filters.text_filter;
      this.$router.push('/attributes/use_cases/history?q=' + this.search);
    },
    onCleanSearch: function onCleanSearch() {
      this.search = '';
      this.filters.text_filter = '';
      this.$router.push('/attributes/use_cases/history?q=' + '');
    },
    init: function init() {
      this.pagination.current = 1;
      this.fetchPage();
    },
    refreshClick: function refreshClick() {
      this.fetchPage();
    },
    downloadSql: function downloadSql() {
      var base64EncodedSql = this.form.descargar_archivo;
      var decodedSql = atob(base64EncodedSql);
      var blob = new Blob([decodedSql], {
        type: 'text/plain'
      });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      if (this.form.type_export_id === 4) {
        link.download = 'archivo.py';
      } else {
        link.download = 'archivo.sql';
      }
      link.click();
      URL.revokeObjectURL(link.href);
    },
    approve: function approve() {
      var _this2 = this;
      var fecha_creacion = this.form.fecha_creacion.substring(0, 10);
      var current_date = utils.getToDayString(new Date());
      var public_table = false;
      if (this.form.carga_unica != 'No') {
        public_table = true;
      } else {
        public_table = this.form.type_export_id == 3 && fecha_creacion == current_date ? true : false;
      }
      var body = {
        'project_id': this.form.project_id,
        'segment_id': this.form.segment_id,
        'type_export_id': this.form.type_export_id,
        'response_request': this.form.response_text,
        'operator': window.userInfo.email,
        'public_table': public_table
      };
      if (this.form.type_export_id === 4) {
        UseCasesService.postAproveTransformedAttributes(body).then(function (response) {
          _this2.setShowLoading(false);
          if (response.code === 200) {
            tasks.toast.success(_this2.translate('success_messages.request_approved'), _this2.translate('titles.success'));
            _this2.onCloseDialog(_this2.DIALOG_VIEW);
            _this2.init();
          } else {
            tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
          }
        }).catch(function (err) {
          console.error(err);
          tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
          _this2.setShowLoading(false);
        });
      } else {
        UseCasesService.postApproveProductize(body).then(function (response) {
          _this2.setShowLoading(false);
          if (response.code === 200) {
            tasks.toast.success(_this2.translate('success_messages.request_approved'), _this2.translate('titles.success'));
            _this2.onCloseDialog(_this2.DIALOG_VIEW);
            _this2.init();
          } else {
            tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
          }
        }).catch(function (err) {
          console.error(err);
          tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
          _this2.setShowLoading(false);
        });
      }
    },
    deny: function deny() {
      var _this3 = this;
      var body = {
        'status_id': 7,
        'response': this.form.response_text,
        'operator': this.form.user,
        'solicitude_type_id': 5
      };
      UseCasesService.patchUpdateProductize(body, this.form.project_id, this.form.segment_id, this.form.type_export_id).then(function (response) {
        _this3.setShowLoading(false);
        if (response.code === 200) {
          tasks.toast.success(_this3.translate('rejected_messages.request_rejected'), _this3.translate('titles.success'));
          _this3.onCloseDialog(_this3.DIALOG_VIEW);
          _this3.init();
        } else {
          tasks.toast.error(_this3.translate('error_messages.error_general'), _this3.translate('titles.error'));
        }
      }).catch(function (err) {
        console.error(err);
        tasks.toast.error(_this3.translate('error_messages.error_general'), _this3.translate('titles.error'));
        _this3.setShowLoading(false);
      });
    }
  }),
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['labelCatalog'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('menu.attrs.manage_productization_subtitle'),
        disabled: true
      }];
    },
    totalRecords: function totalRecords() {
      if (this.items.length === 0) {
        return 0;
      } else {
        return this.pagination.total;
      }
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }),
  watch: {
    'pagination.current': function paginationCurrent(val) {
      this.fetchPage();
    },
    'pagination.limit': function paginationLimit(val) {
      this.pagination.current = 1;
      this.fetchPage();
    }
  }
};